var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMicrosofticon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "100%",
    height: "100%",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.6242 9.37582H19.9868V0.63736C19.9868 0.292814 19.7072 0.0131836 19.3626 0.0131836H10.6242V9.37582Z",
    fill: "#4CAF50"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37582 9.37582V0.0131836H0.63736C0.292814 0.0131836 0.0131836 0.292814 0.0131836 0.63736V9.37582H9.37582Z",
    fill: "#F44336"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.37582 10.6242H0.0131836V19.3626C0.0131836 19.7072 0.292814 19.9868 0.63736 19.9868H9.37582V10.6242Z",
    fill: "#2196F3"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M10.6242 10.6242V19.9868H19.3626C19.7072 19.9868 19.9868 19.7072 19.9868 19.3626V10.6242H10.6242Z",
    fill: "#FFC107"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMicrosofticon);
export default __webpack_public_path__ + "static/media/microsoft icon.52dc5b2b538f89e32281eb5dcce01250.svg";
export { ForwardRef as ReactComponent };